import { render, staticRenderFns } from "./discounttype.vue?vue&type=template&id=2afe6cf2&"
import script from "./discounttype.vue?vue&type=script&lang=js&"
export * from "./discounttype.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports